import { Injectable } from '@angular/core';
import { AppConfig } from '../model/appConfig';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configUrl = './assets/config/appsettings.json';
  private configCache$: Observable<any>;  
  public values: AppConfig;

  constructor(private http: HttpClient) { }

  loadConfig(): Observable<any> {
    if (!this.configCache$) {
      console.log('Loading configuration from:', this.configUrl);
      this.configCache$ = this.http.get<any>(this.configUrl).pipe(
        tap(config => {
          console.log('Configuration loaded successfully');
          this.values = config;
        }),
        catchError(error => {
          console.error('Failed to load configuration', error);
          return throwError(() => new Error('Failed to load application configuration.'));
        }),
        shareReplay(1)
      );
    }
    return this.configCache$;
  }


  get(key: string): string {
    return this.values ? this.values[key] : null;
  }

}
